import React, { useEffect, useRef, useState } from "react";
import { FormControl, FormGroup, FormLabel, Button } from "react-bootstrap";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { useProfile } from "../components/ProfileContext";
import { SimpleFormField } from "../components/SimpleFormField";
import { Timestamp } from "../components/Timestamp";
import { downloadPdfDocumentToNewWindow, formatFilename, inspectionSearch, setNavAdvisoryLockout } from "../util/utils";
import { Inspection } from "../models/Inspection";
import { SpinnerButton } from "../components/SpinnerButton";

export function InspectionSearchPage(props) {
	setNavAdvisoryLockout(false);

	let params = useParams();
	let startingSearchId = params.externalIdentifier;

	let inspNumberRef = useRef();
	let [profile] = useProfile();
	let [found, setFound] = useState(false);
	let [searching, setSearching] = useState(!!startingSearchId);
	let [data, setData] = useState(null);
	let performSearch = async () => {
		try {
			setData(await inspectionSearch(inspNumberRef.current.value));
			setFound(true);
		} catch(err) {
			alert(`Unable to find inspection: ${err}`);
		}
	};

	useEffect(() => {
		if(searching) {
			performSearch();
			setSearching(false);
		}
	});

	return (
		<div className="inspectionSearchContainer">
			<h1>Search Inspections</h1>

			<FormGroup>
				<FormLabel>Enter Inspection #</FormLabel>
				<SimpleFormField type="text" inputRef={inspNumberRef} defaultValue={startingSearchId} scannable={true} afterScan={performSearch}></SimpleFormField>
			</FormGroup>
			<Button className="search" onClick={performSearch}>Search</Button>

			{found && <div className="mt-4 table-responsive">
				<table className="table searchTable">
					<thead>
						<tr>
							<th>Sticker</th>
							<th>Date</th>
							<th>Asset #</th>
							<th>Model</th>
							<th>Serial</th>
							<th>Inspector</th>
							<th>Result</th>
							<th>Download</th>
						</tr>
					</thead>
					<tbody>
						{data.length == 0 && <tr><td colSpan={4}>No results found.</td></tr>}
						{data.map(insp => <React.Fragment key={insp.id}>
							<InspectionSearchResult inspectionData={insp} />
						</React.Fragment>)}
					</tbody>
				</table>
			</div>}

			{ profile == null && <div>
				<hr />
				<Link to="/login">Return to Login</Link>
			</div>}

		</div>
	)
}

function InspectionSearchResult(props) {
	let { inspectionData: insp } = props;
	let [generating, setGenerating] = useState(false);

	insp
	let downloadPDFAction = async () => {
		setGenerating(true);
		let fullInspection = await Inspection.loadInspection(null, insp.id, insp.sharingCode);
		let pdf = await Inspection.generatePdfDocumentFromInspections(null, [fullInspection]);
		await downloadPdfDocumentToNewWindow(pdf, formatFilename("pdf", fullInspection.componentAssetNumber));
		setGenerating(false);
	};

	return <tr>
		<td>{insp.externalIdentifier}</td>
		<td><Timestamp dateString={insp.completedAt} /></td>
		<td>{insp.componentAssetNumber}</td>
		<td>{insp.componentModelNumber}</td>
		<td>{insp.componentSerialNumber}</td>
		<td>{insp.inspectorIdentifier || "None"}</td>
		<td>{insp.result}</td>
		<td><SpinnerButton spinning={generating} onClick={downloadPDFAction}>PDF</SpinnerButton></td>
	</tr>;
}